import { render, staticRenderFns } from "./RejectionCauseForm.vue?vue&type=template&id=5c01f0a2"
import script from "./RejectionCauseForm.vue?vue&type=script&lang=js"
export * from "./RejectionCauseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports